import { Alert, AlertTitle, Button, Container, FormControl, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useRef, useState } from "react";
import { FaCloudUploadAlt, FaPlus, } from "react-icons/fa";
import Loadingspinner from "../../../components/Loadingspinner";
import { Adduserurl, base_url } from "../../../utils/chaturls";
import { usertypes } from "../../../utils/arrays";
import { Cropper } from "react-cropper";
import 'cropperjs/dist/cropper.css';
import { base64tofile, checkimageextension, getBase64 } from "../../../utils/functions";


const Addagent = ({ onsuccess, ondismiss }) => {

    //basics
    const [agentname, setagentname] = useState('');
    const [loginaccount, setloginaccount] = useState('');
    const [usertype, setusertype] = useState('');
    const [password, setpassword] = useState('');
    const [cpassword, setcpassword] = useState('');
    const [phone, setphone] = useState('');
    const [profilepic, setprofilepic] = useState('');
    const [profilepicstring, setprofilepicstring] = useState('');


    const [profilepicname, setprofilepicname] = useState('');
    const [picturestringtocrop, setpicturestringtocrop] = useState('');
    const [tempprofilepicstring, settempprofilepicstring] = useState('');


    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [loading, setloading] = useState(false);


    const cropperRef = useRef(null);
    const onCrop = () => {
        const cropper = cropperRef.current?.cropper;
        settempprofilepicstring(cropper.getCroppedCanvas().toDataURL());
    };

    const submit = async () => {
        seterror()
        if (!agentname) { seterror("agent name is empty") }
        else if (!loginaccount) { seterror("agent email is empty") }
        else if (!password) { seterror("password is empty") }
        else if (!cpassword) { seterror("confirm password field is empty") }
        else if (!phone) { seterror("Agent phone number is empty") }
        else if (password !== cpassword) { seterror("the two passwords do not match") }
        else {
            setloading(true)
            const formData = new FormData();
            formData.append(//append profile pic
                "profilepic",
                profilepic,
                profilepicname
            );

            formData.append('username', agentname);
            formData.append('phone', phone);
            formData.append('email', loginaccount);
            formData.append('password', password);
            formData.append('type', usertype);
            formData.append('baseurl', base_url);
            const config = { headers: { 'content-type': 'multipart/form-data' } }
            axios.post(Adduserurl, formData, config).then(response => {
                setloading(false)
                if (!response.data.error) {
                    setsuccess("Staff added successfully")
                    setTimeout(() => {
                        setsuccess()
                        onsuccess()
                    }, 2000);
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}
            });
        }
    }



    //set profile pic url
    const onchangeprofilepic = (pic) => {
        if (pic) {
            if (!checkimageextension(pic.name)) {
                seterror("Unsupported Format")
                setTimeout(() => { seterror() }, 2000);
            } else {
                setprofilepicname(pic.name)
                getBase64(pic, (result) => {
                    setpicturestringtocrop(result)
                    // setprofilepicstring(result)
                })
            }
        }
    }
    //finish profile pic croppings
    const finishcropping = () => {
        setprofilepic(base64tofile(tempprofilepicstring, profilepicname))
        setprofilepicstring(tempprofilepicstring)
        setpicturestringtocrop()
        settempprofilepicstring()
    }




    return (
        <Modal
            open={true}
            onClose={() => ondismiss()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container sx={{
                backgroundColor: "white",
                marginTop: 5,
                padding: 4,
                borderRadius: 5
            }} maxWidth="md">
                {error?.length > 0 &&
                    <Alert severity="error">
                        <AlertTitle>Error</AlertTitle>
                        {error} — <strong>check it out!</strong>
                    </Alert>}
                {success?.length > 0 &&
                    <Alert severity="success">
                        <AlertTitle>Success</AlertTitle>
                        {success}
                    </Alert>}
                {loading && <Loadingspinner />}
                <div className="overflowdiv" style={{ padding: 5 }}>

                    <Container maxWidth="md" className="containerwithshadow" style={{ marginTop: 30 }}>
                        <Typography sx={{ fontWeight: "bold" }}>
                            Add user
                        </Typography>

                        <div style={{ marginTop: 30, flexWrap: "wrap" }}>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Name:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: 500 }}
                                    value={agentname}
                                    FormHelperTextProps={{ fontSize: 10 }}
                                    onChange={(e) => setagentname(e.target.value)}
                                    inputProps={{ fontSize: 10 }}
                                    placeholder="name"
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Tel:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: 500 }}
                                    value={phone}
                                    onChange={(e) => setphone(e.target.value)}
                                    type="tel"
                                    autoComplete="tel"
                                    inputProps={{ fontSize: 10 }}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Role:
                                </div>
                                <FormControl sx={{ m: 1, minWidth: 500, marginTop: -0.5, marginLeft: -0.1 }} size="small">
                                    <Select
                                        labelId="demo-select-small"
                                        id="demo-select-small"
                                        value={usertype}
                                        onChange={(e) => setusertype(e.target.value)}
                                    >
                                        {usertypes?.map((text, key) => {
                                            return (
                                                <MenuItem key={key} value={text}>{text}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Passport Photo{profilepic && `(${profilepic?.name})`}&nbsp;&nbsp;
                                </div>
                                <div>
                                    {picturestringtocrop &&
                                        <Cropper
                                            src={picturestringtocrop}
                                            style={{ height: 400, width: "100%" }}
                                            aspectRatio={12 / 12}
                                            guides={false}
                                            crop={onCrop}
                                            ref={cropperRef}
                                        />
                                    }
                                    {picturestringtocrop && <Button sx={{ mt: 2, mb: 2 }} onClick={() => finishcropping()} variant="contained" >DONE</Button>}

                                    <input
                                        id="profilepic"
                                        type="file"
                                        name={"profile pic"}
                                        onInput={(e) => onchangeprofilepic(e.target.files[0])}
                                        style={{ display: "none" }}
                                    />
                                    <label for="profilepic"  >
                                        {profilepicstring && !picturestringtocrop && <img src={profilepicstring} width={100} height={100} />}
                                        {!profilepicstring && !picturestringtocrop &&
                                            <div className="uploaddivsmall">
                                                <FaCloudUploadAlt size={70} color="silver" /><br />
                                                <text style={{ color: "silver" }}> Click to upload </text>
                                            </div>
                                        }
                                    </label><br />
                                </div>
                            </div>
                            <h5 >Login account</h5>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Login account:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: 500 }}
                                    value={loginaccount}
                                    onChange={(e) => setloginaccount(e.target.value)}
                                    inputProps={{ fontSize: 10 }}
                                    type="email"
                                    autoComplete="email"
                                    placeholder="*email address"
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Password:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: 500 }}
                                    value={password}
                                    onChange={(e) => setpassword(e.target.value)}
                                    inputProps={{ fontSize: 10 }}
                                    type="password"
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }}>
                                    Confirm password:
                                </div>
                                <TextField
                                    id="outlined-basic"
                                    sx={{ maxHeight: 20, marginRight: 10, marginBottom: 2, width: 500 }}
                                    value={cpassword}
                                    onChange={(e) => setcpassword(e.target.value)}
                                    inputProps={{ fontSize: 10 }}
                                    type="password"
                                    security={true}
                                    variant="outlined" size="small" /><br />
                            </div>
                            <div style={{ marginBottom: 15, display: "flex" }}>
                                <div style={{ fontSize: 15, width: "18%", marginTop: 5, textAlign: "right" }} />
                                <Button onClick={() => submit()} variant="contained" startIcon={<FaPlus size={10} />} sx={{ height: 30, fontSize: 12 }}>Submit</Button>
                            </div>
                        </div>
                    </Container>
                </div>
            </Container>
        </Modal>
    )
}

export default Addagent